import React, { FC } from 'react';
import { Form as FormikForm, Formik, FormikHelpers } from 'formik';

import { CreateUserSegmentInput, SegmentStatus, useCreateUserSegmentMutation } from 'api';
import { SegmentSchema } from 'features/admin/validations';
import { useCreateSegment } from 'features/admin/updaters';
import { useNotify } from 'hooks';

import Title from './Title';

type Values = CreateUserSegmentInput;
type Helpers = FormikHelpers<CreateUserSegmentInput>;

const EMPTY_SEGMENT: CreateUserSegmentInput = {
  title: '',
  segment_status: SegmentStatus.Disabled,
};

const SegmentCreate: FC = () => {
  const notify = useNotify();

  const mutationOptions = useCreateSegment();
  const { mutateAsync, isLoading } = useCreateUserSegmentMutation({
    onSuccess: createNotify,
    ...mutationOptions,
  });

  function createNotify() {
    notify.info({ i18n: { i18nKey: 'common:saved' } });
  }

  async function handleCreate(values: Values, helpers: Helpers) {
    await mutateAsync({ data: values });
    helpers.resetForm();
  }

  return (
    <Formik initialValues={EMPTY_SEGMENT} onSubmit={handleCreate} validationSchema={SegmentSchema}>
      <FormikForm>
        <Title working={isLoading} activeIcon={false} mode="create" />
      </FormikForm>
    </Formik>
  );
};

export default SegmentCreate;
